import axios from "axios";
import { Auth } from "@aws-amplify/auth";

let isSessionExpired = false;
let sessionExpiredCallback = null;

/**
 * Setup axios interceptor to handle session expiration globally
 * When server returns 401 with SESSION_EXPIRED error, trigger callback to show modal
 * @param {Function} onSessionExpired - Callback to trigger when session expires (e.g., show modal)
 */
export const setupAxiosInterceptor = (onSessionExpired) => {
    sessionExpiredCallback = onSessionExpired;
    // Response interceptor
    axios.interceptors.response.use(
        (response) => {
            // Return successful response as-is
            return response;
        },
        async (error) => {
            // Check if error response indicates session expiration
            if (error.response) {
                const { status, data } = error.response;

                // Check for 401 status with SESSION_EXPIRED error message
                if (status === 401 && data && data.error) {
                    const errorMessage = typeof data.error === "string" ? data.error : "";

                    // Check if error message contains "session has expired" or "session expired"
                    if (errorMessage.toLowerCase().includes("session") && errorMessage.toLowerCase().includes("expired")) {
                        // Prevent multiple simultaneous logout attempts
                        if (!isSessionExpired) {
                            isSessionExpired = true;

                            console.log("Session expired detected, showing modal...");

                            // Call the session expired callback (to show modal)
                            if (sessionExpiredCallback && typeof sessionExpiredCallback === "function") {
                                sessionExpiredCallback();
                            }
                        }
                    }
                }
            }

            // Re-throw the error for component-level handling
            return Promise.reject(error);
        }
    );
};

/**
 * Logout user and redirect to login page
 * Called when user confirms the session expired modal
 */
export const logoutAndRedirect = async () => {
    try {
        // Clear local storage
        localStorage.removeItem("token");
        localStorage.removeItem("sub");
        localStorage.removeItem("currencyCode");
        localStorage.removeItem("tenantId");

        // Sign out from AWS Amplify
        try {
            await Auth.signOut();
        } catch (authError) {
            console.error("Error signing out from Amplify:", authError);
        }

        // Redirect to login page
        window.location.href = "/";
    } catch (error) {
        console.error("Error handling session expiration:", error);
        // Force redirect even if there's an error
        window.location.href = "/";
    }
};

/**
 * Reset session expired flag (useful for testing)
 */
export const resetSessionExpiredFlag = () => {
    isSessionExpired = false;
};
